module.exports = __webpack_public_path__ + "cd36beccdd506e99949196a25aecd8de.png";